import { channelEntries } from '@/mocks/homeData';

export default function ChannelRail() {
  return (
    <section id="entry" className="bg-background-50 py-10 md:py-12">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        {/* sparse intro header */}
        <div className="flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <p className="inline-flex items-center gap-1.5 rounded-md bg-secondary-100 px-2.5 py-1 text-xs font-medium text-secondary-900">
              <i className="ri-map-pin-2-line"></i>现场分区速览
            </p>
            <h2 className="mt-3 font-display text-2xl font-bold text-foreground-950 md:text-[28px]">从哪条入口吃，你来定</h2>
          </div>
          <a href="#live" className="inline-flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 whitespace-nowrap">
            进实时快讯 <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        {/* channel cards */}
        <div className="mt-6 grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-5">
          {channelEntries.map((ch) => (
            <a
              key={ch.id}
              href={`#${ch.id === 'ch-1' ? 'toplist' : 'live'}`}
              className={`group flex flex-col rounded-xl border p-4 transition-all hover:-translate-y-0.5 hover:border-primary-300 ${
                ch.featured ? 'border-primary-200 bg-primary-50' : 'border-background-200 bg-background-100'
              }`}
            >
              <div className="flex items-start justify-between">
                <span className={`flex h-10 w-10 items-center justify-center rounded-lg ${ch.featured ? 'bg-primary-500 text-background-50' : 'bg-background-50 text-primary-600 border border-background-200'}`}>
                  <i className={`${ch.icon} text-lg`}></i>
                </span>
                <span className={`rounded-full px-2 py-0.5 text-[10px] font-semibold ${ch.featured ? 'bg-primary-600 text-background-50' : 'bg-secondary-200 text-secondary-900'}`}>
                  {ch.tag}
                </span>
              </div>
              <h3 className="mt-3 text-sm font-semibold text-foreground-950">{ch.name}</h3>
              <p className="mt-1 text-xs leading-relaxed text-foreground-600">{ch.desc}</p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}